import React from "react";
import { Tabs, Tab } from "@mui/material";
import { ReportProblemOutlined } from "@mui/icons-material";
import * as Styled from "../../styles";

interface TabsNavigationProps {
  currentTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onTabClick: (tabValue: number) => void;
  errors?: {
    basicInfos?: boolean;
    credentials?: boolean;
    creditCardBrands?: boolean;
  };
  showCredentialsTab?: boolean;
  showBrandsTab?: boolean;
}

function TabsNavigation({
  currentTab,
  onTabChange,
  onTabClick,
  errors,
  showCredentialsTab = true,
  showBrandsTab = true,
}: TabsNavigationProps) {
  const basicInfosHasErrors = !!errors?.basicInfos;
  const credentialsHasErrors = !!errors?.credentials;
  const creditCardBrandsHasErrors = !!errors?.creditCardBrands;

  return (
    <Styled.ContainerTabsNavigation>
      <Tabs value={currentTab} onChange={onTabChange} variant="fullWidth">
        <Tab
          label="Informações Básicas"
          icon={
            basicInfosHasErrors ? (
              <ReportProblemOutlined
                fontSize="small"
                sx={{ color: "#D33100" }}
              />
            ) : undefined
          }
          iconPosition="start"
          value={1}
          onClick={() => onTabClick(1)}
        />
        {showCredentialsTab && (
          <Tab
            label="Credenciais"
            icon={
              credentialsHasErrors ? (
                <ReportProblemOutlined
                  fontSize="small"
                  sx={{ color: "#D33100" }}
                />
              ) : undefined
            }
            iconPosition="start"
            value={2}
            onClick={() => onTabClick(2)}
          />
        )}
        {showBrandsTab && (
          <Tab
            label="Bandeiras"
            icon={
              creditCardBrandsHasErrors ? (
                <ReportProblemOutlined
                  fontSize="small"
                  sx={{ color: "#D33100" }}
                />
              ) : undefined
            }
            iconPosition="start"
            value={3}
            onClick={() => onTabClick(3)}
          />
        )}
      </Tabs>
    </Styled.ContainerTabsNavigation>
  );
}

export default TabsNavigation;
